module.exports = __webpack_public_path__ + "static/media/ZonaPro-Regular.a0957131.woff";